<template>
    <div class="multi-image-upload">
        <!-- 图片列表 -->
        <div class="image-list">
            <div v-for="(img, index) in imageList" :key="index" class="image-item">
                <img :src="getImageUrl(img)" />
                <i class="el-icon-delete" @click="removeImage(index)"></i>
            </div>
            
            <!-- 上传按钮 -->
            <el-upload
                v-if="imageList.length < limit"
                ref="upload"
                action=""
                :show-file-list="false"
                :before-upload="beforeUpload"
                :http-request="handleUpload"
                accept="image/*"
                class="upload-btn">
                <i class="el-icon-plus"></i>
            </el-upload>
        </div>
        
        <div class="tips" v-if="tips">
            {{ tips }}
        </div>
    </div>
</template>

<script>
import global from "../../../api/global";
import { reqUploadFile } from '@/api/system'

export default {
    name: 'MultiImageUpload',
    props: {
        /* 图片列表 */
        value: {
            type: Array,
            default: () => []
        },
        /* 限制大小 KB */
        maxSize: {
            type: Number,
            default: 2048
        },
        /* 最大数量 */
        limit: {
            type: Number,
            default: 9
        },
        /* 提示文字 */
        tips: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            imageList: [],
            filePre: global.preview_path_url
        }
    },
    watch: {
        value: {
            handler(v) {
                // 同步外部数据到内部
                if (v && Array.isArray(v)) {
                    this.imageList = [...v]
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // 获取图片URL
        getImageUrl(img) {
            if (!img) return ''
            // 如果已经是完整URL，直接返回
            if (typeof img === 'string') {
                return img.startsWith('http') ? img : this.filePre + img
            }
            // 如果是对象，取url属性
            if (typeof img === 'object') {
                const url = img.url || img.response?.data
                return url ? (url.startsWith('http') ? url : this.filePre + url) : ''
            }
            return ''
        },
        
        // 上传前验证
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/')
            const isLt = file.size / 1024 < this.maxSize
            
            if (!isImage) {
                this.$message.warning('只能上传图片')
                return false
            }
            if (!isLt) {
                this.$message.warning(`图片大小不能超过 ${this.maxSize}KB`)
                return false
            }
            if (this.imageList.length >= this.limit) {
                this.$message.warning(`最多只能上传${this.limit}张图片`)
                return false
            }
            
            return true
        },
        
        // 自定义上传处理
        async handleUpload(options) {
            const { file } = options
            
            try {
                const formData = new FormData()
                formData.append('file', file)
                
                const res = await reqUploadFile(formData)
                if (res && res.data) {
                    // 添加到列表
                    this.imageList.push(res.data)
                    
                    // 触发 v-model 更新
                    this.$emit('input', [...this.imageList])
                    
                    this.$message.success('图片上传成功')
                    console.log('图片上传成功，URL:', res.data)
                } else {
                    this.$message.error('图片上传失败')
                }
            } catch (error) {
                console.error('图片上传失败', error)
                this.$message.error('图片上传失败: ' + (error.message || '未知错误'))
            }
        },
        
        // 删除图片
        removeImage(index) {
            this.imageList.splice(index, 1)
            this.$emit('input', [...this.imageList])
            this.$emit('remove', index)
        },
        

    }
}
</script>

<style lang="scss" scoped>
.multi-image-upload {
    display: inline-block;
}

.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.image-item {
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    i {
        position: absolute;
        top: -8px;
        right: -8px;
        cursor: pointer;
        background: #fff;
        border-radius: 50%;
        color: #f56c6c;
        font-size: 18px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
        z-index: 1;
        
        &:hover {
            color: #f78989;
        }
    }
}

.upload-btn {
    ::v-deep .el-upload {
        width: 100px;
        height: 100px;
        line-height: 100px;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        cursor: pointer;
        
        &:hover {
            border-color: #409EFF;
        }
        
        i {
            font-size: 28px;
            color: #8c939d;
        }
    }
}

.tips {
    color: #999;
    font-size: 12px;
    margin-top: 5px;
}
</style>
